<script lang="ts">
  import DashboardLayout from '../DashboardLayout.svelte';
  import DashHero from '../shared/DashHero.svelte';
  import LabQueueWidget from '../widgets/LabQueueWidget.svelte';
  import QuickActions from '../widgets/QuickActions.svelte';
  import { Laboratorio } from '../../../lib/api';

  let { onNavigate }: { onNavigate: (tab: string) => void } = $props();

  let cola = $state({ sol: 0, proc: 0, res: 0 });

  async function cargar() {
    const [a, b, c] = await Promise.all([
      Laboratorio.ordenes('SOLICITADA').catch(() => []),
      Laboratorio.ordenes('EN_PROCESO').catch(() => []),
      Laboratorio.ordenes('RESULTADOS_LISTOS').catch(() => []),
    ]);
    cola = { sol: a.length, proc: b.length, res: c.length };
  }

  const actions = [{ id: 'laboratorio', label: 'Ir a LIS', icon: '🧪' }];

  $effect(() => { cargar(); const t = setInterval(cargar, 30000); return () => clearInterval(t); });
</script>

<DashboardLayout title="Laboratorio (LIS)" subtitle="Cola operativa" variant="laboratorio">
  <DashHero emoji="🧪" title="Laboratorio (LIS)" subtitle="Cola operativa — solicitudes, procesamiento y validación" variant="laboratorio" />
  <QuickActions {actions} onAction={onNavigate} />

  <div class="dash-kpis">
    <div class="dash-kpi"><div class="dash-kpi-label">Solicitadas</div><div class="dash-kpi-value">{cola.sol}</div></div>
    <div class="dash-kpi"><div class="dash-kpi-label">En proceso</div><div class="dash-kpi-value">{cola.proc}</div></div>
    <div class="dash-kpi"><div class="dash-kpi-label">Resultados listos</div><div class="dash-kpi-value">{cola.res}</div></div>
    <div class="dash-kpi"><div class="dash-kpi-label">Total cola</div><div class="dash-kpi-value">{cola.sol + cola.proc + cola.res}</div></div>
  </div>

  <div class="dash-grid">
    <div class="col-12"><LabQueueWidget limit={15} interactive /></div>
  </div>
</DashboardLayout>
